import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import * as styles from './index.module.scss';

import cardLinkType from '../../lib/utils/card-link-type';
import { PrevButton, NextButton, usePrevNextButtons } from './slider-arrow-navigation';

const SliderContainer = ({ slides, blockIndex }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, slidesToScroll: 1, dragFree: false });

    const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

    return(
        slides.length > 3 ?
        <section
            className={`${styles.slider} embla`}
        >
            <div
                className={`${styles.viewport} embla__viewport`}
                ref={emblaRef}
            >
                <div
                    className={`${styles.slider_container} embla__container`}
                >
                    {slides && slides.map((slide, index) => {

                        return(
                            <article
                                className={`${styles.slider_slide} embla__slide`}
                                key={`slider-${blockIndex}-slide${index}`}
                            >
                                <a
                                    className={`${styles.link}`}
                                    href={`${cardLinkType(slide?.internal?.type)}${slide.slug}`}
                                >
                                    <div
                                      className={styles.imageWrapper}
                                    >
                                        { slide?.featuredImage &&
                                          <GatsbyImage 
                                            alt={slide?.title}
                                            className={styles.image} 
                                            image={getImage(slide?.featuredImage)} 
                                          />
                                        }
                                        { slide?.date && 
                                          <p className={styles.date}>{slide?.date}</p>
                                        }
                                    </div>
                                    <div
                                      className={styles.info}
                                    >
                                      <p 
                                        className={styles.title}
                                      >{slide?.title}</p>
                                      <span
                                        className={styles.readMore}
                                      >Read More</span>
                                    </div>
                                </a>
                            </article>
                        )
                    })}
                </div>
            </div>

            <div className={`${styles.controls} embla__controls`}>
                <div className="embla__buttons">
                    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                </div>
            </div>
        </section>
        :
        <div
            className={styles.cards}
        >
          {slides && slides.map((slide, index) => {
            return(
              <article
                className={`${styles.card}`}
                key={`product-case-studies-slide${index}`}
              >
                <a
                  className={`${styles.link}`}
                  href={`${cardLinkType(slide?.internal?.type)}${slide.slug}`}
                >
                  <div
                    className={styles.imageWrapper}
                  >
                    { slide?.featuredImage &&
                      <GatsbyImage 
                        alt={slide?.title}
                        className={styles.image} 
                        image={getImage(slide?.featuredImage)} 
                      />
                    }
                    { slide?.date && 
                      <p className={styles.date}>{slide?.date}</p>
                    }
                  </div>
                  <div
                    className={styles.info}
                  >
                    <p 
                      className={styles.title}
                    >{slide?.title}</p>
                    <span
                      className={styles.readMore}
                    >Read More</span>
                  </div>
                </a>
              </article>
            )
          })}
        </div>
    )
}

export default SliderContainer;